import { render } from "./DoctorsPanel.vue?vue&type=template&id=8d22dc16&scoped=true"
import script from "./DoctorsPanel.vue?vue&type=script&lang=js"
export * from "./DoctorsPanel.vue?vue&type=script&lang=js"

import "./DoctorsPanel.vue?vue&type=style&index=0&id=8d22dc16&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d22dc16"]])

export default __exports__